import React, { Component } from 'react';
import { Modal, WingBlank, WhiteSpace, Button, Toast } from 'antd-mobile';
import { CommonlyHeadMembers } from '../../common/headnav';
import * as services from '../../projects/services';
import { createBrowserHistory } from "history";
import './style.less';
const alert = Modal.alert;
const history = createBrowserHistory();
let page = 1;
let rows = 10;
let total = 0;
let firstshow = false;
export default class ReportList extends Component {
    constructor(props) {
        super(props);
        page = 1;
        rows = 10;
        total = 0;
        this.state = {
            params: { page: page, rows: rows },
            reportData: [],
            total: 0,
        }
    }
    componentDidMount() {
        firstshow = true;
        services.GetReportList(this.state.params, '正在查询，请稍后').then((data) => {

            if (data.status === 0) {
                total = data.result.total;
                this.setState({ reportData: data.result.rows, total: data.result.total });
            } else {
                Toast.offline(data.message);
            }
        })

        const wrapper = this.refs.wrapper;
        const loadMoreDataFn = this.loadMoreDataFn;
        let timeCount;
        function callback() {
            const top = wrapper.getBoundingClientRect().top;
            const windowHeight = window.screen.height;
            if (top && top < windowHeight + 1 && total / rows >= page) {
                page++;
                loadMoreDataFn(page);
            }
        }
        window.addEventListener('scroll', function () {
            if (this.state.isLoadingMore) {
                return;
            }
            if (timeCount) {
                clearTimeout(timeCount);
            }

            timeCount = setTimeout(callback, 50);
        }.bind(this), false);

    }
    //再次加载
    loadMoreDataFn = (page) => {
        let params = this.state.params;
        params.page = page;
        this.setState({
            params: params,
        });
        services.GetReportList(this.state.params, '正在查询，请稍后').then(data => {

            if (data.status === 0) {
                this.setState({
                    reportData: this.state.reportData.concat(data.result.rows),
                });

            } else {
                Toast.offline(data.message);
            }


        })
    }
    addReport = () => {
        history.push('/members/report/add');
        history.go();
    }
    interpret = (rid, e) => {
        history.push('/members/interpret/' + rid);
        history.go();
    }
    showAlert = (rid, e) => {
        const alertInstance = alert('解绑', '您确定解绑该体检报告吗？', [
            { text: '我再想想', onPress: () => '' },
            {
                text: '确定解绑', onPress: () => {
                    services.RelieveReport(rid, '正在解绑，请稍后').then(data => {
                        if (data.status === 0) {

                            Toast.success(data.message);
                            let params = this.state.params;
                            params.page = 1;
                            this.setState({
                                params: params,
                            });
                            services.GetReportList(params, '').then((data) => {
                                if (data.status === 0) {
                                    this.setState({ reportData: data.result.rows, total: data.result.total });
                                } else {
                                    Toast.offline(data.message);
                                }
                            })


                        } else {
                            Toast.offline(data.message);
                        }
                    })
                }
            },
        ]);
        setTimeout(() => {
            // 可以调用close方法以在外部close
            alertInstance.close();
        }, 500000);
    }
    render() {
        const { reportData } = this.state;
        return <div className="report">
            <CommonlyHeadMembers barname="健康档案" />
            <WingBlank>
                {
                    reportData.length === 0 && firstshow ? <div className="errordiv"><img alt='' src={require('../../../res/images/zwsj.png')} />
                        <p>您还没有绑定过报告！</p>
                    </div> :
                        reportData.map((data, index) => (
                            <div key={index}>
                                <WhiteSpace size="lg" />
                                <div className="integralbox">
                                    <div className="integral-title">
                                        <span >体检编号：{data.reportno}</span>
                                        <span ><Button className=" cenbutc" onClick={this.showAlert.bind(this, data.reportid)} >解绑</Button></span>
                                    </div>
                                    <div className="integral-cen" >
                                        <div className="cen-box">
                                            <div className="cen-b"><span>姓&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;名：{data.realname}</span></div>
                                            <div className="cen-b"><span>体检中心：{data.mcname}</span></div>
                                            <div className="cen-b"><span>总检日期：{data.releasedate}</span></div>
                                            {
                                                !!data.reporttel ?
                                                    <div className="cen-b"><span>报告咨询电话：
                                                <a href={'tel:' + data.reporttel}> {data.reporttel}</a>
                                                    </span></div>
                                                    : ''
                                            }
                                        </div>
                                        <div className="cen-but">
                                            <Button className="cenbut" onClick={
                                                () => {
                                                    history.push(`/members/report/detail/${data.reportno}/${data.ckmm}/${data.mcno}`);
                                                    history.go();
                                                }
                                            } >查看详情</Button>
                                            <Button className="cenbut" onClick={this.interpret.bind(this, data.reportid)}  >开始解读</Button>
                                            <Button className="cenbut" onClick={
                                                () => {
                                                    history.push(`/members/report/eidtreportpsw/${data.reportno}/${data.ckmm}/${data.mcno}/${data.mcname}`);
                                                    history.go();
                                                }
                                            }  >密码修改</Button>


                                        </div>
                                    </div>
                                </div>
                            </div>
                        ))
                }

                <div ref="wrapper"></div>
                <WhiteSpace size="lg" />
                <WhiteSpace size="lg" />
                <WhiteSpace size="lg" />
                <WhiteSpace size="lg" />
            </WingBlank>

            <div className="footer">
                <div className="footerbox footerbox2">
                    <Button className="inline-addbut" onClick={this.addReport}>添加体检报告</Button>
                </div>
            </div>
        </div>;
    }
}